/* BG CC presale reviews — video thumbnails open the mp4 in a native <dialog> (replaces Ella's Fancybox).
   Plays with sound on open (user gesture), pauses and unloads on close; Esc, the close button and a
   backdrop click all close it; focus returns to the thumbnail. */
if (!customElements.get('bg-ccp-video-reviews')) {
  customElements.define(
    'bg-ccp-video-reviews',
    class BgCcpVideoReviews extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.bg-ccp-dialog');
        this.video = this.dialog?.querySelector('video');
        if (!this.dialog || !this.video) return;

        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-video]');
          if (trigger && this.contains(trigger)) this.open(trigger);
        });
        this.dialog.querySelector('.bg-ccp-dialog__close')?.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.onClose());
      }

      open(trigger) {
        this.trigger = trigger;
        this.video.src = trigger.dataset.video;
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.body.style.overflow = 'hidden';
        const playing = this.video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(() => {});
      }

      onClose() {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        document.body.style.overflow = '';
        this.trigger?.focus();
      }
    }
  );
}
